// extracted by mini-css-extract-plugin
export default {"fullWidth":"on-z","image":"pn-z","lazyLoadPicture":"qn-z","lazyLoadSpinner":"rn-z","lazyLoadSpin":"sn-z","lazyLoadImage":"tn-z","hasStyledAspectRatio":"un-z"};